enum ErrorWarning {
    Valid = 1,
    Warning,
    Error 
}

export default ErrorWarning